const firebaseConfig = {
    apiKey: "AIzaSyAtBt9yReIbt-TwTouw9SBvqszp5sIuJTQ",
    authDomain: "automantia-authantication.firebaseapp.com",
    projectId: "automantia-authantication",
    storageBucket: "automantia-authantication.appspot.com",
    messagingSenderId: "687863920592",
    appId: "1:687863920592:web:b6e9582b6ec83efaeeabd5"
  };

export default firebaseConfig;